import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { BioAwards } from './components/BioAwards';
import { useGetPlayerProfileQuery } from 'store/modules/api/statsPro-api';
import { useGetCompetitionsQuery } from 'common/store/modules/api/afl-api';

/**
 * @param root0
 * @param root0.data
 * @param root0.seasonId
 * @param root0.playerProviderId
 * @param root0.aflwSeasonId
 * @param root0.compId
 * @returns {JSX.Element} Component.
 */
export const PlayerProfileBio = ({ playerProviderId, compId }) => {
    const totalGamesRef = useRef(null);
    const debutYearRef = useRef(null);

    const { competition } = useGetCompetitionsQuery(
        {},
        {
            selectFromResult: ({ data }) => ({
                competition: data?.find((item) => item.id === parseInt(compId))
            })
        }
    );

    useEffect(() => {
        const totalGamesEl = document.querySelector('.js-total-games');
        const debutYearEl = document.querySelector('.js-debut-year');

        if (totalGamesEl) {
            totalGamesRef.current = totalGamesEl;
        }
        if (debutYearEl) {
            debutYearRef.current = debutYearEl;
        }

        return () => {
            totalGamesRef.current = null;
            debutYearEl.current = null;
        };
    }, []);

    const { data } = useGetPlayerProfileQuery(
        {
            playerId: playerProviderId,
            competitionCode: competition?.providerId
        },
        {
            skip: !playerProviderId || !competition?.providerId
        }
    );

    if (data?.careerTotals?.matchesPlayed && totalGamesRef.current) {
        totalGamesRef.current.innerHTML =
            data.careerTotals.matchesPlayed.toString();
    }

    if (
        data?.playerDetails?.debutYear &&
        debutYearRef.current &&
        debutYearRef.current.innerHTML === '-'
    ) {
        debutYearRef.current.innerHTML =
            data.playerDetails.debutYear.toString();
    }

    return data ? <BioAwards data={data} /> : <></>;
};

PlayerProfileBio.propTypes = {
    playerProviderId: PropTypes.string.isRequired,
    compId: PropTypes.string.isRequired
};
